import Auth from '@aws-amplify/auth';
import { injectable } from 'inversify';

@injectable()
export default class UserService {
  async logout(): Promise<void> {
    await Auth.signOut();
  }
}
